var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"generic-faq-tabs",attrs:{"aria-label":"Gestion de la FAQ Code du travail"}},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.path,staticClass:"generic-faq-tabs__item",attrs:{"to":link.path}},[_vm._v(" "+_vm._s(link.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }